import type { ActivationAlertsContractAlertsDataType } from "@similarweb/pro-api-client";

import { swSettings } from "app/common/services/swSettings";

import type { ExcelDataId } from "./types";

type ExcelDataTypeConfig = {
    id: ExcelDataId;
    translationKey: string;
    apiValue: ActivationAlertsContractAlertsDataType;
}[];

export const EXCEL_DATA_TYPES_CONFIG: ExcelDataTypeConfig = [
    { id: "news", translationKey: "activation.alerts.excel-popup.option.news", apiValue: "News" },
    {
        id: "socialMedia",
        translationKey: "activation.alerts.excel-popup.option.socialMedia",
        apiValue: "SocialPosts",
    },
    {
        id: "ads",
        translationKey: "activation.alerts.excel-popup.option.ads",
        apiValue: "Ads",
    },
    {
        id: "websiteContent",
        translationKey: "activation.alerts.excel-popup.option.websiteContent",
        apiValue: "WebsiteContent",
    },
];

export const getExcelDataTypesConfig = (): ExcelDataTypeConfig => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- SwSettings is untyped
    return swSettings.user.isInternalUser
        ? EXCEL_DATA_TYPES_CONFIG
        : EXCEL_DATA_TYPES_CONFIG.filter((dataType) => dataType.id !== "ads");
};
